import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://oggimlzaqkxuxetkjelc.supabase.co';
const SUPABASE_KEY = 'sb_publishable_X6cs6xexY0zJoYjJTSJrvQ_ZWgjenCf';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: window.localStorage,
    storageKey: 'dialygo-auth',
  },
  realtime: { params: { eventsPerSecond: 10 } },
});
